import React from 'react';
import { Space } from 'antd';
import {
  GoogleOutlined,
  LinkOutlined,
  SnippetsOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  GlobalOutlined,
  AppstoreOutlined,
} from '@ant-design/icons';

export const CONNECTOR_CONFIG = [
  // {
  //   key: 'google-workspace',
  //   label: 'Google Workspace',
  //   description: 'Google Drive integrations',
  //   icon: <GoogleOutlined className="text-lg" />,
  //   pills: ['Google Drive'],
  // },
  {
    key: 'link',
    label: 'Link',
    description: 'Import from web',
    icon: <LinkOutlined className="text-lg" />,
    pills: ['Website'],
  },
  {
    key: 'paste-text',
    label: 'Paste text',
    description: 'Add copied content',
    icon: <SnippetsOutlined className="text-lg" />,
    pills: ['Copied text'],
  },
];

export const NOTES = {
  link: [
    'Add each website URL on its own row using the Add URL button.',
    'Only the visible text on the website will be imported.',
    'Paid articles are not supported.',
  ],
  'paste-text': [
    'You can paste up to 15,000 characters at once.',
    'Formatting will be preserved where possible.',
    'Save often to avoid losing changes.',
  ],
  'google-workspace': [
    'Connect your Google account to browse available files.',
    'Use filters to choose the right Drive or Shared Drive.',
    'Only files you have access to will appear.',
  ],
};

export const TITLE_COPY = {
  upload: {
    title: 'Add sources',
    description:
      'Sources let our RAG agents base its responses on the information that matters most to you. Upload files or connect integrations to power your RAG agents.',
  },
  'google-workspace': {
    title: 'Google Workspace',
    description:
      'Browse your Google Drive and choose the files you want to sync. We recommend keeping your folders organised for seamless imports.',
  },
  link: {
    title: 'Website URLs',
    description:
      'Paste in web URLs below to upload as sources. The visible text on each page will be imported into your knowledge base.',
  },
  'paste-text': {
    title: 'Paste copied text',
    description:
      'Paste any copied notes or snippets and we will turn them into a datasource for your RAG agents.',
  },
};

export const PLACEHOLDER_COPY = {
  link: 'Paste URLs*',
  'paste-text': 'Paste text here*',
};

export const WEBSITE_TYPE_OPTIONS = [
  {
    value: 'shopify',
    label: (
      <Space size={8}>
        <ShopOutlined className="text-emerald-500" />
        <span>Shopify</span>
      </Space>
    ),
  },
  {
    value: 'woocommerce',
    label: (
      <Space size={8}>
        <ShoppingCartOutlined className="text-blue-500" />
        <span>WooCommerce</span>
      </Space>
    ),
  },
  {
    value: 'wordpress',
    label: (
      <Space size={8}>
        <GlobalOutlined className="text-slate-500" />
        <span>WordPress</span>
      </Space>
    ),
  },
  {
    value: 'wix',
    label: (
      <Space size={8}>
        <AppstoreOutlined className="text-purple-500" />
        <span>Wix</span>
      </Space>
    ),
  },
  {
    value: 'custom',
    label: (
      <Space size={8}>
        <AppstoreOutlined className="text-purple-500" />
        <span>Custom Website</span>
      </Space>
    ),
  },
];
